export const scores = [1, 2, 3, 4];
